<template>
	<v-layout row wrap>
		<v-flex xs12>
				<p class="my-0">
					<label class="black--text">* App Name</label>
			</p>
			<v-text-field
				v-model="input.name"
				placeholder="App Name"
				dense
				hide-details
				outline />
				<small class="grey--text text--darken-2 ml-1">
						Any name from your choice
					</small>
		</v-flex>
		<v-flex xs12 v-if="!put">
				<p class="my-0">
					<label class="black--text">* App ID</label>
			</p>
			<v-text-field
				v-model="input.app_id"
				placeholder="App ID"
				dense
				hide-details
				outline />
				<small class="grey--text text--darken-2 ml-1">
						You will find it under your phone number settings.
					</small>
		</v-flex>
		<v-flex xs12 v-if="!put">
				<p class="my-0">
					<label class="black--text">* Key ID</label>
			</p>
			<v-text-field
				v-model="input.key_id"
				placeholder="Key ID"
				dense
				hide-details
				outline />
			<small class="grey--text text--darken-2 ml-1">
					You will find it under your account settings.
			</small>
		</v-flex>
		<v-flex xs12  v-if="!put">
				<p class="my-0">
					<label class="black--text">* Secret</label>
			</p>
			<v-text-field
				v-model="input.secret"
				placeholder="Secret"
				dense
				hide-details
				outline />
				<small class="grey--text text--darken-2 ml-1">
						You will find it under your account settings.
					</small>
		</v-flex>
		<v-flex xs12  v-if="!put">
				<p class="my-0">
					<label class="black--text">* Service Link</label>
			</p>
			<v-text-field
				v-model="input.service_url"
				placeholder="Service Link"
				dense
				hide-details
				outline />
				<small class="grey--text text--darken-2 ml-1">
						It can be https://api.smooch.io for example
					</small>
		</v-flex>
		<v-flex xs12>
				<p class="my-0">
					<label class="black--text">* Namespace</label>
			</p>
			<v-text-field
				v-model="input.namespace"
				placeholder="Namespace"
				dense
				hide-details
				outline />
				<small class="grey--text text--darken-2 ml-1">
						Ask your support team to get it.
					</small>
		</v-flex>
		<v-flex xs12>
				<p class="my-0">
					<label class="black--text">* Tier Limit</label>
			</p>
			<v-text-field
				v-model="input.tier_limit"
				placeholder="Tier Limit"
				type="number"
				@blur="handleTierLimitBlur"
				dense
				hide-details
				outline />
				<small class="grey--text text--darken-2 ml-1">
						The max number of message your account can send per day.
					</small>
		</v-flex>
	</v-layout>
</template>

<script>
export default {

  name: 'AddSmoochApp',
  props: {
  put: {
  		type: Object,
  		default: null
  	}
  },
  data () {
    return {
    	input: {
    		name: '',
    		app_id: '',
    		key_id: '',
    		secret: '',
    		service_url: '',
    		namespace: '',
    		tier_limit: 1000
    	}
    }
  },
  computed: {
  	botId() {
  		return this.$store.state.bot.botId
  	}
  },
  watch: {
  	put: {
  		deep: true,
  		immediate: true,
  		handler(val) {
  			if(val) {
  				const c = val
  				if (c && c.tier_limit && c.tier_limit.toString) {
  					c.tier_limit =  val.tier_limit.toString()
  				} else {
  					c.tier_limit = '1000'
  				}
  				this.input = c;
  				this.handleTierLimitBlur()
  			} else {
  				this.input =  {
		    		name: '',
		    		app_id: '',
		    		key_id: '',
		    		secret: '',
		    		service_url: '',
		    		namespace: '',
		    		tier_limit: 1000
		    	}
  			}
  		}
  	}
  },
  methods: {
  	validateInput() {
  		let keys = Object.keys(this.input)
  		if(this.put) {
  			keys = this.$_.pick(keys, ['name', 'namespace', 'tier_limit'])
  		}
  		let i
  		for(i = 0; i < keys.length; i += 1) {
  			if(this.input[keys[i]] !== null && this.input[keys[i]] !== undefined) {
  				if(typeof this.input[keys[i]] === 'string' && !this.input[keys[i]].length) {
  					console.log(keys[i], 1)
  					return false
  				}
  			} else {
  				console.log(keys[i], 2)
  				return false
  			}
  		}
  		return true
  	},
  	handleTierLimitBlur() {
  		if(!this.input.tier_limit || !this.input.tier_limit.length) {
  			this.input.tier_limit = '1000'
  		} else if(isNaN(this.input.tier_limit)) {
  			this.input.tier_limit = '1000'
  		} else if (parseFloat(this.input.tier_limit, 10) < 1000 || parseFloat(this.input.tier_limit, 10) > 100000) {
  			this.input.tier_limit = '1000'
  		}
  	},
  	submit() {
  		if(!this.validateInput()) {
  			this.$store.dispatch('setErrorMessage', 'You are missing some mandatory fields to be filled, please fill them first and resubmit.');
  			return;
  		}
  		let payload = this.$_.cloneDeep(this.input)
  		payload.tier_limit = parseFloat(payload.tier_limit, 10)
  		if(this.put) {
  			payload = this.$_.omit(payload, ['tier_daily_consumed', '_id', 'status'])
  		}
  		this.$emit('loading', true)
  		this.$http_chat.put(`/bots/${this.botId}/apps/smooch${ this.put ? '' : '/connect'}`, payload)
  			.then(res => {
  				this.$emit('success', res.data)
  				this.$emit('loading', false)
  			})
  			.catch((err)=>{
  				const msg = err.response && err.response.data && err.response.data.message
              ?  err.response.data.message.error : true
          this.$store.dispatch('setErrorMessage', msg);
          this.$emit('loading', false)
        })
    }
  }
}
</script>

<style lang="css" scoped>
</style>
